




















































































import {
  Component, Mixins, Watch,
} from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import AuthModule from '@/store/modules/Auth';
import PointModule from '@/store/modules/Point';
import Table from '@/components/Table/Index.vue';
import Breadcrumb from '@/components/Breadcrumb.vue';
import PointBody from '@/components/Table/PointBody.vue';
import LogBody from '@/components/Table/RewardLogBody.vue';
import Pagination from '@/components/Pagination.vue';
import PointData from '@/data/PointData';
import ToolMixin from '@/mixins/Tool.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import PaginationMixin from '@/mixins/Pagination.vue';
import ProductDropdown from '@/components/ProductDropdown.vue';
import { IPointCriteria } from '@/interface/pointReport';
import DateRangeLogBody from '@/components/Table/DateRangeLog.vue';

@Component({
  components: {
    Table,
    Breadcrumb,
    Pagination,
    PointBody,
    LogBody,
    ProductDropdown,
    DateRangeLogBody,
  },
})
export default class Point extends Mixins(
  ToolMixin, ErrorHandleMixin, PaginationMixin,
) {
  AuthInstance = getModule(AuthModule, this.$store);

  PointInstance = getModule(PointModule, this.$store);

  Criteria: IPointCriteria = {
    ...this.Period,
    isSearch: false,
    role: this.AuthInstance.user.role,
    userId: this.AuthInstance.user._id,
    username: this.AuthInstance.user.username,
    source: this.AuthInstance.user.source,
    limit: 100,
    page: 1,
  };

  BreadcrumbList: any = [];

  BreadcrumbDefault = [
    {
      username: this.AuthInstance.user.username,
      source: this.AuthInstance.user.source,
      role: this.AuthInstance.user.role,
      userId: this.AuthInstance.user._id,
    },
  ];

  type = '';

  resultData: object = {};

  dataList: any = [];

  LoginName = '';

  TableHeadMember = [...PointData.TableHeadMember];

  FilteredTableHeadMember: Array<object> = [...PointData.TableHeadMember];

  TableHeadLog: any = [];

  mode = 'agent';

  isMember = false;

  startdate = '';

  enddate = '';

  isSuperadmin = false;

  footSummery: object = {};

  isSearch = false;

  PaginationDetail = {
    current: 1,
    amount: 0,
    size: 100,
  }

  pointFetch = 'member';

  personLog = {};

  momentFormat = {
    stringify: (date) => this.$moment(date).format('DD-MM-YYYY'),
    parse: (value) => this.$moment(value).format('DD-MM-YYYY'),
  }

  @Watch('Period.start.date', { immediate: true, deep: true })
  watchperiod() {
    const datestart = this.$moment(this.Period.start.date).format('L');
    this.startdate = this.$moment(datestart).format('DD-MM-YYYY');
  }

  @Watch('Period.end.date', { immediate: true, deep: true })
  watchperiod2() {
    const dateend = this.$moment(this.Period.end.date).format('L');
    this.enddate = this.$moment(dateend).format('DD-MM-YYYY');
  }

  created() {
    this.BreadcrumbList = this.BreadcrumbDefault;
    this.isSuperadmin = ['SUPERADMIN'].includes(this.AuthInstance.user.role);
    this.fetchPoint();
  }

  initial() {
    this.currentTool = 'Today';
    this.Period = {
      start: {
        date: this.$moment().startOf('day').toDate(),
      },
      end: {
        date: this.$moment().endOf('day').toDate(),
      },
    };
    this.Criteria = {
      ...this.Period,
      isSearch: false,
      role: this.AuthInstance.user.role,
      userId: this.AuthInstance.user._id,
      username: this.AuthInstance.user.username,
      source: this.AuthInstance.user.source,
      limit: 100,
      page: 1,
    };
    this.LoginName = '';
    this.isMember = false;
  }

  async fetchPoint() {
    if (this.LoginName) {
      this.isSearch = true;
      this.Criteria.isSearch = true;
    } else {
      this.isSearch = false;
      this.Criteria.isSearch = false;
    }
    this.pointFetch = 'member';
    this.mode = 'agent';
    this.FilteredTableHeadMember[0] = [...PointData.TableHeadMember[0]];
    this.GeneralInstance.toggleLoading(true);
    const result = await this.PointInstance.FetchPointReport({
      ...this.Period,
      ...this.Criteria,
    });
    if (result.data) {
      this.PaginationDetail.amount = result.pageAmount;
      this.resultData = result.data.map((value, idx) => ({
        ...value,
        index: idx + ((this.PaginationDetail.current - 1) * 100) + 1,
      }));
      this.footSummery = result.footerSummary;
      this.BreadcrumbList = [...this.BreadcrumbDefault, ...result.breadcrumb];
      this.GeneralInstance.toggleLoading(false);
    } else {
      this.checkError(result.status);
      this.GeneralInstance.toggleLoading(false);
    }
    this.isSearch = false;
  }

  onSubmit() {
    if (this.pointFetch === 'member') {
      this.fetchPoint();
    } else {
      this.fetchPointLog(this.personLog);
    }
  }

  changePage(i: number) {
    this.PaginationDetail.current = i;
    this.Criteria.page = i;
    if (this.pointFetch === 'member') {
      this.fetchPoint();
    } else {
      this.fetchPointLog(this.personLog);
    }
  }

  handleSearch() {
    this.isMember = this.AuthInstance.user.role === 'ADMIN';
    this.Criteria.username = this.LoginName
      ? this.LoginName
      : this.AuthInstance.user.username;
    this.isSearch = true;
  }

  handlefetchPointAgent(data: object) {
    this.beforeFetch(data);
  }

  handleBreadcrumb(data: object) {
    this.beforeFetch(data);
  }

  beforeFetch(data: any = {}) {
    this.isMember = data.role === 'MEMBER';
    this.LoginName = '';
    this.Criteria.username = data.username;
    this.Criteria.source = data.source;
    this.Criteria.role = data.role;
    this.Criteria.userId = data.id || data.userId || data._id;
    this.PaginationDetail.current = 1;
    this.Criteria.page = 1;
    if (this.isMember) {
      this.fetchPointLog(data);
    } else {
      this.fetchPoint();
    }
  }

  async fetchPointLog(data: object) {
    this.personLog = data;
    this.pointFetch = 'log';
    if (this.isMember) {
      this.mode = 'member';
    }
    this.FilteredTableHeadMember[0] = [...PointData.TableHeadLog[0]];
    this.GeneralInstance.toggleLoading(true);
    const logReward = await this.PointInstance.FetchPointLog({
      ...this.Period,
      data,
      page: this.Criteria.page,
      limit: 100,
    });
    this.PaginationDetail.amount = logReward.pageAmount;
    this.resultData = logReward.data;
    this.BreadcrumbList = [...this.BreadcrumbDefault, ...logReward.breadcrumb];
    this.GeneralInstance.toggleLoading(false);
    this.isSearch = false;
  }
}
